import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaCheckCircle, FaTimesCircle, FaExclamationCircle } from "react-icons/fa";

function PaymentStatusModal({
  show,
  onClose,
  isSuccess,
  msg,
  title,
  btnTitle,
  handler,
  paymentHandler,
  showPayBtn = false,
}) {
  console.log(btnTitle);
  console.log(paymentHandler);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      style={{
        borderRadius: "20px",
      }}
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: isSuccess ? "2px solid #28a745" : "2px solid #dc3545",
          backgroundColor: isSuccess ? "#f0f9f4" : "#fff5f5",
          borderRadius: "20px 20px 0 0",
          padding: "20px 25px",
        }}
      >
        <Modal.Title
          style={{
            color: isSuccess ? "#28a745" : "#dc3545",
            fontWeight: "700",
            fontSize: "20px",
          }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "30px 25px" }}>
        <div className="text-center">
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: isSuccess ? "#d4edda" : "#f8d7da",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              animation: "scaleIn 0.3s ease-out",
            }}
          >
            {isSuccess ? (
              <FaCheckCircle
                style={{
                  fontSize: "50px",
                  color: "#28a745",
                }}
              />
            ) : (
              <FaTimesCircle
                style={{
                  fontSize: "50px",
                  color: "#dc3545",
                }}
              />
            )}
          </div>
          <p
            style={{
              color: isSuccess ? "#155724" : "#721c24",
              fontSize: "16px",
              lineHeight: "1.6",
              fontWeight: "500",
              margin: "0",
            }}
          >
            {msg}
          </p>
        </div>
      </Modal.Body>
      {(showPayBtn || btnTitle) && (
        <Modal.Footer
          style={{
            borderTop: "1px solid #e0e0e0",
            padding: "20px 25px",
            borderRadius: "0 0 20px 20px",
          }}
        >
          <div className="d-flex gap-2 w-100 justify-content-end">
            {showPayBtn && (
              <Button
                variant="primary"
                onClick={paymentHandler}
                className="fw-semibold px-4 py-2"
                style={{
                  borderRadius: "10px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 15px rgba(0, 123, 255, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 6px 20px rgba(0, 123, 255, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 4px 15px rgba(0, 123, 255, 0.3)";
                }}
              >
                Pay
              </Button>
            )}
            {btnTitle && (
              <Button
                variant={isSuccess ? "success" : "danger"}
                onClick={handler}
                className="fw-semibold px-4 py-2"
                style={{
                  borderRadius: "10px",
                  transition: "all 0.3s ease",
                  boxShadow: isSuccess
                    ? "0 4px 15px rgba(40, 167, 69, 0.3)"
                    : "0 4px 15px rgba(220, 53, 69, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = isSuccess
                    ? "0 6px 20px rgba(40, 167, 69, 0.4)"
                    : "0 6px 20px rgba(220, 53, 69, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = isSuccess
                    ? "0 4px 15px rgba(40, 167, 69, 0.3)"
                    : "0 4px 15px rgba(220, 53, 69, 0.3)";
                }}
              >
                {btnTitle}
              </Button>
            )}
          </div>
        </Modal.Footer>
      )}
      <style>
        {`
          @keyframes scaleIn {
            from {
              transform: scale(0);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
          .modal-content {
            border-radius: 20px !important;
            border: none !important;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;
          }
          .modal-header .btn-close {
            font-size: 18px;
            opacity: 0.6;
            transition: opacity 0.3s ease;
          }
          .modal-header .btn-close:hover {
            opacity: 1;
          }
        `}
      </style>
    </Modal>
  );
}

export default PaymentStatusModal;
